export default __webpack_public_path__ + "static/media/pencil-white.959fa90a.svg";